/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import Vuex from 'vuex';

import store from './store.js'

import VeeValidate from 'vee-validate'
import DateRangePicker from 'vue2-daterange-picker'
import Vue from 'vue';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import VueHtmlToPaper from 'vue-html-to-paper';
// import VueEcho from 'vue-echo-laravel';
import Clipboard from 'v-clipboard';
import * as Sentry from "@sentry/vue";
import PlatformBrand from './plugins/platformBrand';
/*
* Use the Vue Material  https://vuematerial.io/
*For system perfomance import necessary componenents in my case
* I am going to import the full package
*
 */

// import VueMaterial from 'vue-material'
// import 'vue-material/dist/vue-material.min.css'
// import 'vue-material/dist/theme/default.css'


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
// import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
// import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'
import VueMyToasts from 'vue-my-toasts'
import 'vue-my-toasts/dist/vue-my-toasts.css'
import BootstrapVueToast from 'vue-my-toasts/src/components/toasts/BootstrapComponent'
import VueSound from 'vue-sound/src/components/VueSound'
import cacheRefreshService from './services/cacheRefreshService';
import identityCache from './services/identityCache';
import canMixin from './mixins/canMixin';
import TrackerPlugin from './plugins/tracker';

cacheRefreshService.start(30 * 60 * 1000); // Refresh every 10 minutes

const vuePrintOptions = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    '/css/print.css',
  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: true, // if false, the window will not close after printing
  windowTitle: window.document.title, // override the window title
}

Vue.use(VueHtmlToPaper, vuePrintOptions);

// or, using the defaults with no stylesheet
Vue.use(VueHtmlToPaper);
Vue.use(VueHtmlToPaper,vuePrintOptions);
Vue.use(VueMyToasts, {
    component: BootstrapVueToast,
    options: {
        width: '400px',
        position: 'top-right',
        padding: '1rem',
    },
});


const datepickerOptions = {};
// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
// var VueDropdown = require('vue-dynamic-dropdown/dropdown');
Vue.component('previewupload', require('./components/ProfilePreviewEditSingle.vue').default);
Vue.component('Inventory', require('./components/inventory/Inventory.vue').default);
Vue.component('DiscountCampaigns', require('./components/inventory/DiscountCampaigns.vue').default);
Vue.component('DiscountCampaignProducts', require('./components/inventory/DiscountCampaignProducts.vue').default);
Vue.component('Purchases', require('./components/inventory/Purchases.vue').default);
Vue.component('BorrowedStock', require('./components/inventory/BorrowedStock.vue').default);
Vue.component('Transfers', require('./components/inventory/Transfers.vue').default);
Vue.component('Requisition', require('./components/inventory/Requisition.vue').default);
Vue.component('GroupedInventory', require('./components/inventory/GroupedInventory.vue').default);
Vue.component('InventoryActivity', require('./components/inventory/InventoryActivity.vue').default);
Vue.component('Expenses', require('./components/expenses').default);
Vue.component('Employees', require('./components/employees/employee').default);
Vue.component('Customers', require('./components/customers/index').default);
Vue.component('CustomerProfile', require('./components/customers/CustomerProfile').default);
Vue.component('CustomerProductInsight', require('./components/customers/CustomersProductInsights').default);
Vue.component('Wastes', require('./components/wastes').default);
Vue.component('Suppliers', require('./components/suppliers/index').default);
Vue.component('SupplierStatement', require('./components/suppliers/supplierStatement').default);
Vue.component('fileuploader', require('./components/fileUploader').default);
Vue.component('Sell', require('./components/Salespage').default);
Vue.component('Search', require('./components/search').default);
Vue.component('Payment', require('./components/paymentpage').default);
Vue.component('checkoutdone', require('./components/checkoutdone').default);
Vue.component('checkout', require('./components/checkout').default);
Vue.component('quantity', require('./components/modal/quantity').default);
Vue.component('ModalCustomers', require('./components/modal/customers').default);
Vue.component('Daterange',require('./components/DateRange').default);
Vue.component('Cashdrawer',require('./components/CashDrawer').default);
Vue.component('Invoice',require('./components/invoice').default);
Vue.component('Orders',require('./components/AllOrders').default);
Vue.component('SalesAnalytics',require('./components/analytics/sales').default);
Vue.component('BottomMenu',require('./components/partials/BottomMenu').default);
Vue.component('ActivationProgress',require('./components/partials/ActivationProgress').default);
Vue.component('BusinessIntelligence',require('./components/partials/BusinessIntelligence').default);
Vue.component('GuidanceAssistant',require('./components/partials/GuidanceAssistant').default);
Vue.component('Services',require('./components/services').default);
Vue.component('FullCal',require('./components/partials/FullCalendar').default);
Vue.component('UserProfile',require('./components/profile').default);
Vue.component('GeneralSettings',require('./components/settings/generalsettings').default);
Vue.component('PaymentsSettings',require('./components/settings/paymentsettings').default);
Vue.component('InventorySettings',require('./components/settings/inventorysettings').default);
Vue.component('ReceiptSettings',require('./components/settings/receiptsettings').default);
Vue.component('IntegrationSettings',require('./components/settings/integrations').default);
Vue.component('FeatureSettings',require('./components/settings/featuresettings').default);
Vue.component('SharaGpt',require('./components/intelligence/SharaGpt').default);
Vue.component('LoyaltySettings',require('./components/settings/loyaltysettings').default);
Vue.component('PackDispatch',require('./components/Fulfillment/PackDispatch').default);
Vue.component('BulkRestock',require('./components/inventory/BulkRestock').default);
Vue.component('IndexReservation',require('./components/Reservations/index').default);
Vue.component('MakeReservation',require('./components/Reservations/MakeReservation').default);
Vue.component('ReservationsToday', require('./components/Reservations/ReservationsToday.vue').default);
Vue.component('IndexPayroll',require('./components/payroll/IndexPayroll').default);
Vue.component('TaxLedger',require('./components/accounting/taxledgers.vue').default);

// Vue.component('Notifications',require('./components/Notifications').default);
Vue.component('LeaveApplications',require('./components/leaveapplications').default);
Vue.component('SalaryAdvance',require('./components/salaryadvances').default);
Vue.component('EmployeeAttendance',require('./components/employees/EmployeeAttendance').default);
Vue.component('Appointments',require('./components/appointments').default);
Vue.component('HomejsData',require('./components/HomejsData').default);
Vue.component('MakeSaleHome',require('./components/MakeSale').default);
Vue.component('OnboardingProcess',require('./components/Onboarding').default);
Vue.component('RegisterBusiness',require('./components/registerbusiness').default);
Vue.component('DashboardSaleschart',require('./components/analytics/charts/dashboardsales').default);
Vue.component('AddProduct',require('./components/inventory/AddProduct').default);
Vue.component('BillingPage',require('./components/BillingPage').default);
Vue.component('BnplPage',require('./components/BNPL').default);
Vue.component('DebtorsPage', require('./components/Debtors.vue').default);
Vue.component('LoaderSpin', require('./components/partials/loader.vue').default);
Vue.component('CustomerInvoice', require('./components/partials/loader.vue').default);
Vue.component('CustomerOrderView', require('./components/customers/CustomerOrderView').default);
Vue.component('CustomerStatementView', require('./components/customers/CustomerStatementView').default);
Vue.component('PaymentLinkView', require('./components/paymentlinks/PaymentLinkView').default);
Vue.component('SharePaymentLinkModal', require('./components/paymentlinks/SharePaymentLinkModal').default);
Vue.component('StockTake', require('./components/inventory/StockTake.vue').default);
Vue.component('InventoryVarianceReport', require('./components/inventory/InventoryVarianceReport.vue').default);
Vue.component('PaymentTransactions', require('./components/Transactions/PaymentTransactions.vue').default);
Vue.component('LedgerTransactions', require('./components/Transactions/LedgerTransactions.vue').default);
Vue.component('ChartOfAccounts', require('./components/Transactions/ChartOfAccounts.vue').default);
Vue.component('Banking', require('./components/Transactions/Banking.vue').default);
Vue.component('SettingsMenu', require('./components/settings/menu.vue').default);
Vue.component('OtpVerification', require('./components/Auth/OtpVerification.vue').default);
Vue.component('LoginWithPhone', require('./components/Auth/LoginWithPhone.vue').default);
Vue.component('KitchenDisplaySys',  require('./components/Sales/KitchenDisplay.vue').default);
Vue.component('SendReceiveMoney', require('./components/DukakitPayments/SendReceiveMoney.vue').default);
Vue.component('KdsAdminDashboard', require('./components/Sales/KdsAdminDashboard.vue').default);
Vue.component('NightAudit', require('./components/Reservations/NightAudit.vue').default);
Vue.component('PushNotification', require('./components/partials/PushNotificationsAndInstall.vue').default);
Vue.component('SubscriptionsIndex', require('./components/subscriptions/SubscriptionsIndex.vue').default);
Vue.component('CancelSubscriptionModal', require('./components/subscriptions/CancelSubscriptionModal.vue').default);
Vue.component('CreateSubscriptionModal', require('./components/subscriptions/CreateSubscriptionModal.vue').default);
Vue.component('RenewSubscriptionModal', require('./components/subscriptions/RenewSubscriptionModal.vue').default);
Vue.component('PackageManager', require('./components/subscriptions/packages/PackageManager.vue').default);
Vue.component('RenewSubscriptionModal', require('./components/subscriptions/RenewSubscriptionModal.vue').default);
Vue.component('SubscriptionDetailsModal', require('./components/subscriptions/SubscriptionDetailsModal.vue').default);
Vue.component('NewAnalytics', require('./components/analytics/AnalyticsDashboard.vue').default);
Vue.component('CategorySales', require('./components/analytics/CategorySales.vue').default);
Vue.component('ReservationDashboard', require('./components/Reservations/ReservationDashboard.vue').default);
Vue.component('BranchManagerModal', require('./components/settings/BranchManagerModal.vue').default);
Vue.component('OpeningCashModal', require('./components/CashSession/OpeningCashModal.vue').default);
Vue.component('RepackModal', require('./components/manufacturing/RepackModal.vue').default);
Vue.component('RecipePinPrompt', require('./components/manufacturing/RecipePinPrompt.vue').default);
Vue.component('CloseShiftModal', require('./components/CashSession/CloseShiftModal.vue').default);
Vue.component('CashShiftControl', require('./components/CashSession/CashShiftControl.vue').default);
Vue.component('AttendanceIndicator', require('./components/AttendanceIndicator.vue').default);
Vue.component('GlobalPaymentBadge', require('./components/global/GlobalPaymentBadge.vue').default);

Vue.component('SubscriptionCheckin', require('./components/subscriptions/SubscriptionCheckinPage.vue').default);
Vue.component('MemberPortal', require('./components/subscriptions/member/MemberPortal.vue').default);
Vue.component('SubscriptionDashboard', require('./components/subscriptions/SubscriptionDashboard.vue').default);
Vue.component('SubscriptionAttendantDashboard', require('./components/subscriptions/SubscriptionAttendantDashboard.vue').default);
// Vue.component('ManufacturingDashboard', require('./components/manufacturing/ManufacturingDashboard').default);
Vue.component('ManufacturingHub', require('./components/manufacturing/Manufacturing.vue').default);

// ── Quotes & Invoices ───────────────────────────────────────────────
Vue.component('ReportCentre', require('./components/reports/ReportCentre.vue').default);
Vue.component('ReceivablesAging', require('./components/reports/ReceivablesAging.vue').default);
Vue.component('LoyaltyReport', require('./components/reports/LoyaltyReport.vue').default);
Vue.component('PayablesAging', require('./components/reports/PayablesAging.vue').default);
Vue.component('QuotesList', require('./components/quotesInvoices/QuotesList.vue').default);
Vue.component('QuoteForm', require('./components/quotesInvoices/QuoteForm.vue').default);
Vue.component('QuoteView', require('./components/quotesInvoices/QuoteView.vue').default);
Vue.component('InvoicesList', require('./components/quotesInvoices/InvoicesList.vue').default);
Vue.component('DeliveryNotesPanel', require('./components/manufacturing/DeliveryNotesPanel.vue').default);
Vue.component('SalesList', require('./components/quotesInvoices/SalesList.vue').default);
Vue.component('InvoiceForm', require('./components/quotesInvoices/InvoiceForm.vue').default);
Vue.component('InvoiceOverviewDashboard', require('./components/quotesInvoices/InvoiceOverviewDashboard.vue').default);
Vue.component('ProjectsIndex', require('./components/projects/ProjectsIndex.vue').default);
Vue.component('PublicRequisitionForm', require('./components/projects/PublicRequisitionForm.vue').default);
Vue.component('InvoiceView', require('./components/quotesInvoices/InvoiceView.vue').default);
Vue.component('CreateFab', require('./components/CreateFab.vue').default);
// Vue.component('BomList', require('./components/manufacturing/BomList.vue').default);
// Vue.component('BomCreate', require('./components/manufacturing/BomForm.vue').default);
// Vue.component('ProductionOrderDetail', require('./components/manufacturing/ProductionOrderDetail.vue').default);
// Vue.component('ProductionOrderForm', require('./components/manufacturing/ProductionOrderForm.vue').default);
// Vue.component('ProductionOrderList', require('./components/manufacturing/ProductionOrderList.vue').default);
// Vue.component('StockLedgerView', require('./components/manufacturing/StockLedgerView.vue').default);
// Vue.component('WastageLog', require('./components/manufacturing/WastageLog.vue').default);




// Intelligence
Vue.component('IntelligenceDashboard', require('./components/intelligence/IntelligenceDashboard.vue').default);
Vue.component('ProductIntelligencePanel', require('./components/intelligence/ProductIntelligencePanel.vue').default);
Vue.component('ConcernDetailModal', require('./components/intelligence/ConcernDetailModal.vue').default);
Vue.component('ConcernCard', require('./components/intelligence/ConcernCard.vue').default);
Vue.component('SeverityBadge', require('./components/intelligence/SeverityBadge.vue').default);

// admin components
Vue.component('AdminDashboard', require('./components/Admin/Dashboard').default);
Vue.component('DukakitLiquidityAdmin', require('./components/DukakitPayments/DukakitLiquidityAdmin.vue').default);
Vue.component('AdminEventAnalytics', require('./components/Admin/AdminEventAnalytics').default);
Vue.component('AffiliatesDashboard', require('./components/affiliates/index').default);

// Vue.component('vue-dropdown',VueDropdown);



// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
Vue.use(PlatformBrand);
/*
* TODO: rem to ENABLE VEEVALIDATE LATER
 */
// Vue.use(VeeValidate);
Vue.use(VueSound);

Vue.use(Clipboard);

// Global permission helper — available as this.can('permission.name') in every component
Vue.mixin(canMixin);

// Activity tracker — this.$track() and v-track directive available in every component
Vue.use(TrackerPlugin);

Vue.use(DateRangePicker);
/*
*Use the Vue Material  https://vuematerial.io/
 */
// Vue.use(VueMaterial);


// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.use(VueTelInput,{
    defaultCountry:'KE',
    autoDefaultCountry:true,
    dropdownOptions:{
      showSearchBox:true,
    },
    inputOptions:{
      placeholder:"E.g 0712345678",
      required:true
    },
    mode:'international'
});

// Vue.use(AirbnbStyleDatepicker, datepickerOptions);

// Vuex
Vue.use(Vuex);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
// Vue.use(VueEcho, {
//   broadcaster: 'pusher',
//   host: window.location.hostname + ':6001',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: false,
//     disableStats: true,
// });

Vue.prototype.convertCurrencyToShillings = function(amount) {
  if (amount === null || amount === undefined) {
    return '';
  }

  let currencyCode = 'KES'; // Default currency
  const userDetailsStr = localStorage.getItem('userDetails');

  // Check if userDetailsStr is not null and parse only if it exists
  if (userDetailsStr) {
    try {
      const userDetails = JSON.parse(userDetailsStr);

      // Check if the company settings and currency exist and are not 'null'
      if (userDetails.company &&
          userDetails.company.companysettings &&
          userDetails.company.companysettings.currency !== 'null') {
        currencyCode = userDetails.company.companysettings.currency;
      }
    } catch (error) {
      console.error("Error parsing userDetails:", error);
    }
  }

  return amount.toLocaleString('en', {
    style: 'currency',
    currency: currencyCode
  });
};

Vue.prototype.convertCurrencyToLocal = function(amount) {
  if (amount === null || amount === undefined) {
    return '';
  }
  let currencyCode =''
  const userDetails = JSON.parse(localStorage.getItem('userDetails'))

  if(userDetails && userDetails.company && userDetails.company.companysettings && userDetails.company.companysettings.currency !=='null')
  {
    currencyCode = userDetails.company.companysettings.currency
  }
  else{
    currencyCode = 'KES';
  }

  return amount.toLocaleString('en', {
    style: 'currency',
    currency: currencyCode
  });
};
Vue.prototype.hasPermission = function(permissionName) {
  const permissions = this.$store.state.userDetails?.permissions;
  if (!Array.isArray(permissions)) return false;
  return permissions.some(p => p.name === permissionName);
};
moment.tz.setDefault('Africa/Nairobi');
Vue.prototype.$moment = moment;

// Introduce sentry
      Sentry.init({
        Vue,
        dsn: "https://a7722dbddd220a85d0cdc2dd3d7c2310@o4508320947568640.ingest.us.sentry.io/4508371254181888",
        integrations: [
          Sentry.replayIntegration(),
        ],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        // Not ours: code injected by browser extensions (e.g. the "M_ID" errors).
        denyUrls: [/^chrome-extension:\/\//i, /^moz-extension:\/\//i, /^safari(-web)?-extension:\/\//i],
        // The user's connection dropped mid-request - nothing to fix on our side.
        // Server errors still arrive as "status code 5xx", not "Network Error".
        // Safari/WebKit kills the IndexedDB process of backgrounded tabs
        // ("Connection to Indexed Database server lost") - a browser bug.
        ignoreErrors: [/^AxiosError: Network Error$/, /^Network Error$/, /Connection to Indexed Database server lost/],
      });
new Vue({
  el: "#app",

  // created, not mounted: child components send their first requests while
  // they are created, before the root mounts — a 401 on page load used to
  // slip past the interceptor instead of redirecting to /login.
  created() {
      this.enableInterceptor();
  },
  mounted() {
      this.fetchActiveCashSession();
  },
  store: new Vuex.Store(store),
  data: {
      isLoading: false,
      axiosInterceptor: null,
  },

  methods: {
      enableInterceptor() {
          const vm = this;

          vm.axiosInterceptor = window.axios.interceptors.request.use((config) => {
              if (!config._silent) vm.isLoading = true;
              return config;
          }, (error) => {
              vm.isLoading = false;
              return Promise.reject(error);
          });

          window.axios.interceptors.response.use((response) => {
              vm.isLoading = false;
              return response;
          }, function (error) {
              vm.isLoading = false;

              // Session expired/invalidated server-side (e.g. logged out elsewhere,
              // force-logout by admin). Wipe identity-scoped caches so the next
              // login on this device never inherits this session's branch data.
              // Excludes /onboarding - a never-logged-in signup visitor getting
              // 401 there is expected (not an expired session), and that page
              // already handles it itself (shows the signup step).
              if (error.response?.status === 401
                  && !window.location.pathname.startsWith('/login')
                  && !window.location.pathname.startsWith('/onboarding')) {
                  identityCache.clearAll().finally(() => {
                      localStorage.clear();
                      window.location.href = '/login';
                  });
                  return new Promise(() => {}); // navigation is happening; don't resolve/reject further
              }

              // Cash session gate: server blocks the request until an opening cash session is opened
              if (
                  error.response?.status === 423 &&
                  error.response?.data?.error === 'CASH_SESSION_REQUIRED' &&
                  !error.config?._cashSessionRetry
              ) {
                  return new Promise((resolve, reject) => {
                      vm.$emit('cash-session-required', {
                          retry() {
                              const cfg = Object.assign({}, error.config, { _cashSessionRetry: true });
                              resolve(window.axios(cfg));
                          },
                          cancel() {
                              reject(error);
                          },
                      });
                  });
              }

              // PIN-protected recipe: ask for its PIN (RecipePinPrompt), then retry the request once.
              if (
                  error.response?.status === 423 &&
                  error.response?.data?.code === 'recipe_locked' &&
                  !error.config?._recipePinRetry
              ) {
                  return new Promise((resolve, reject) => {
                      vm.$emit('recipe-pin-required', {
                          recipe: error.response.data.recipe || {},
                          retry() {
                              resolve(window.axios(Object.assign({}, error.config, { _recipePinRetry: true })));
                          },
                          cancel() {
                              reject(error);
                          },
                      });
                  });
              }

              return Promise.reject(error);
          });
      },

      fetchActiveCashSession() {
          const settings = this.$store.state.userDetails?.company?.companysettings;
          if (!settings?.enable_opening_cash) return;

          window.axios.get('/api/cash-sessions/active')
              .then(({ data }) => {
                  if (data) {
                      this.$store.commit('setCashSession', data);
                  }
              })
              .catch(() => {});
      },

      disableInterceptor() {
          window.axios.interceptors.request.eject(this.axiosInterceptor);
      },
  },
})

